import api from './baseService';

export const getSubmissionAssets = (submissionId: string) =>
	api().get(`/pdb/products/submissions/${submissionId}/assets`);

export const getSubmissionDetails = (submissionId: string) =>
	api().get(`/pdb/submissions/${submissionId}`);

export const getSubmissionActivityLog = (submissionId: string) =>
	api().get(`/pdb/submissions/${submissionId}/activities`);

export const getSubmissionTestResult = (submissionId: string) => 
	api().get(`/pdb/submissions/${submissionId}/test_result`);
